// 注册页面翻译
export default {
  title: "用户注册",
  subtitle: "创建您的新账号",
  switchToLogin: "已有账户？登录",

  // 表单字段标签和占位符
  account: "账号",
  accountPlaceholder: "请输入账号",
  phone: "手机号",
  phonePlaceholder: "请输入手机号",
  captcha: "验证码",
  captchaPlaceholder: "请输入短信验证码",
  password: "密码",
  passwordPlaceholder: "8-16位，至少包括字母、数字、特殊字符组合",
  confirmPassword: "确认密码",
  confirmPasswordPlaceholder: "请再次确认密码",

  // 按钮文本
  register: "注册",
  getCaptcha: "获取验证码",
  closeDialog: "关闭弹窗",
  backToLogin: "返回登录",

  // 成功提示
  registerSuccess: "注册成功",
  registerSuccessSubtitle: "添加企业微信申请更多服务！",

  // 错误消息
  registerFailed: "注册失败请重试",
  getCaptchaFirst: "请先获取验证码或验证码已过期！",

  // 表单验证消息
  validation: {
    accountRequired: "请输入账号",
    accountLength: "长度在 2 到 20 个字符",
    phoneRequired: "请输入手机号码",
    phoneFormat: "请输入正确的手机号",
    captchaRequired: "请输入验证码",
    captchaFormat: "验证码格式不对",
    passwordRequired:
      "非中文字符8-16位，至少1个字母，1个数字和1个特殊字符的组合",
    passwordLength: "非中文字符8-16位，至少1个字母，1个数字和1个特殊字符的组合",
    passwordPattern:
      "非中文字符8-16位，至少1个字母，1个数字和1个特殊字符的组合",
    passwordAscii: "请输入8-16位的非中文字符",
    passwordLetter: "请输入至少1个字母",
    passwordNumber: "请输入至少1个数字",
    passwordSpecial: "请输入至少1个非中文特殊字符",
    confirmPasswordRequired: "请再次输入密码",
    passwordMismatch: "两次输入的密码不一致，请重新输入",
  },
};
